module.exports = {"id":"167516","name":"Miroslav Radović","rating":"74","photo":"./data/images/photos/4/167516.png","club":{"name":"Legia Varsovie","logo":"./data/images/clubs/LegiaVarsovie.png"},"positions":["MOC","MG","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MiroslavRadovic0.json
// module id = 3055
// module chunks = 0